import { Component, OnInit, ViewChild } from '@angular/core';
import { GiftCardClientsModel } from 'src/app/models/gifcardVirtual.model';
import { GifcardVirtualService } from 'src/app/services/gifcardVirtual.service';
import { MessageService, ConfirmationService } from 'primeng/api';

@Component({
    selector: 'clients-list',
    templateUrl: 'clients-list.component.html',
    styleUrls: ['clients-list.component.css']
})

export class ClientListComponent implements OnInit {

    selectClient: GiftCardClientsModel;
    datasourceSelectClient: GiftCardClientsModel[] = [];
    colsTablaClients: any[]; 
    dlgCliente: boolean = false;
    loading: boolean = false;

    constructor(private giftCardService: GifcardVirtualService, 
        private confirmationService: ConfirmationService,
        private messageService: MessageService) { }

    ngOnInit() { 
        this.loading = true;
        this.createColumnsTablaClients();
        this.populateTableClients();
        this.giftCardService.removeClientEdit();
    }

    createColumnsTablaClients(){
        this.colsTablaClients = [
            { field: 'ID_CLIENTE', header: 'ID' },
            { field: 'NRORUC_CLIENTE', header: 'RUC' },
            { field: 'RAZSOC_CLIENTE', header: 'Razón Social' },
            { field: 'ESTADO', header: 'Estado' }
        ];
    }

    populateTableClients(){
        this.giftCardService.GetGiftCardClientsAll().subscribe(
            (response: GiftCardClientsModel[]) => {            
                this.datasourceSelectClient = response;    
                this.loading = false; 
            },
            (error) => {
                this.messageService.add({severity:'error', summary: 'Error', detail:'Ocurrio un error al listar clientes.'});
            }
        )
    }

    editClient(client: GiftCardClientsModel){
        if (client){
            this.giftCardService.setClientEdit(client);            
        }      
    }

    onShowConfirmDeBaja(client: GiftCardClientsModel) {
        this.confirmationService.confirm({
            message: '¿Está seguro dar de baja al cliente?',
            accept: () => {        
                this.lowClient(client);
            },
            reject: () => {
                
            }
        });
    }

    lowClient(client: GiftCardClientsModel){
        this.loading = true;  
        let params = {
            "p_id_cliente": client.ID_CLIENTE,
            "p_ruc_cliente": client.NRORUC_CLIENTE,
            "p_razon_cliente": client.RAZSOC_CLIENTE,
            "p_flag_activo": 0
        };    
        this.giftCardService.UpdateClient(params).subscribe(
            (response) => {          
                this.populateTableClients();
                this.loading = false;
                this.messageService.add({severity:'success', summary: 'Éxito', detail:'El cliente se dió de baja correctamente'});
            },
            (error) => {
                this.loading = false;
                this.messageService.add({severity:'error', summary: 'Error', detail:'Ocurrio un error al dar de baja al cliente'});
            }
        )
    }
}